<template>
  <div class="content">
    <div class="material" id="materialid">
      <materialScienceline v-if="monitorType == 'A1'" :caseList="caseList" @deleteFiel="deleteFiel"></materialScienceline>
      <materialSciencelineSpan
        v-else
        :caseList="caseList"
        :fieldType="fieldType"
        @deleteFiel="deleteFiel"
      ></materialSciencelineSpan>
    </div>

    <div class="bottom-btn">
      <div class="divclass1" v-if=" caseList && caseList.length < 10">
        <!-- 直接调原生的上传文件按钮 -->
        <cusbtn1 ref="resetfile" @fields="getFields" v-if="monitorType === 'A1'"></cusbtn1>
        <!-- 调起底部弹窗的 -->
        <cusBtn3 v-if="monitorType === 'A2'" @click="choiceFielType"></cusBtn3>
      </div>
      <!--上报按钮 -->
      <cusBtn2 class="btn2" @click="uploadBtn"></cusBtn2>
    </div>
    <uploadmodal :isShow="isShow" @cancel="cancelClick" :content="titleContent" @onOk="onOk"></uploadmodal>

    <div>
      <!-- <scrollpicker></scrollpicker> -->
      <commonPicker
        ref="commonPickerfiletype"
        @fields="getFieldsType"
        :typeList="newQuarterList"
        :title="title"
        :cols="cols1"
        :monitorType="monitorType"
        :year="year"
        :quarter="quarter"
        :area="area"
        :needEmit="isNeedemit"
      ></commonPicker>
    </div>
  </div>
</template>
<script>
import materialScienceline from "./components/materialScience_line";
import materialSciencelineSpan from "./components/materialScience_span_line";

import cusbtn1 from "./components/cusBtn1";
import cusBtn2 from "./components/cusBtn2";
import cusBtn3 from "./components/cusBtn3";
import uploadmodal from "./components/uploadModal";

import commonPicker from "../../../components/base/myCommonPicker";

import API from "../../../service/index";
import commonAPI from "../../../utils/common";

export default {
  components: {
    materialScienceline,
    cusbtn1,
    cusBtn2,
    uploadmodal,
    cusBtn3,
    materialSciencelineSpan,
    commonPicker,
  },
  data() {
    return {
      cusmarker: false,
      caseList: this.$route.query.fields,
      monitorType: this.$route.query.monitorType,
      fielKind: this.$route.query.fielKind,
      fieldType: this.$route.query.fieldType,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      area: this.$route.query.area,
      id: this.$route.query.id,
      isShow: false,
      isNeedemit: true,
      tempFile: [],
      titleContent: "",
      cols1: 1,
      title: "选择附件类型",
      newQuarterList: [],
      markermodal: 1,
      outisShow: false,
      outtitle: "",
      outtitleContent: "",
    };
  },
  created() {
    this.getFileKind();
  },

  methods: {
    initDetailFiles() {
      this.caseList = [];
      API.getDetailByA1A2({
        monitorType: this.monitorType,
        area: this.area,
        quarter: this.quarter,
        year: this.year,
      }).then((res) => {
        console.log("----A1A2:", res);
        if (res.ret == 0 && res.data) {
          this.deductionDetail = res.data;
          this.decutionID = res.data.id;
          if (res.data.fileResVOS && res.data.fileResVOS.length > 0) {
            this.caseList = res.data.fileResVOS;
          }
        }
      });
    },
    deleteFiel(value) {
      // console.log('------value:', value);
      API.deleteFileA1A2({
        fileId: value.id,
        id: this.id,
        batchCode: "",
        monitorType: this.monitorType,
      }).then((res) => {
        console.log("删除成功");
        const newdata = this.caseList.filter(
          (item) => item.filePath !== value.filePath
        );
        this.caseList = [];
        for (let i = 0; i < newdata.length; i++) {
          this.caseList.push(newdata[i]);
        }
        document.getElementById("materialid").scrollIntoView(false);
        if (this.$refs.resetfile) {
          this.$refs.resetfile.resetFile();
        }
        if (this.$refs.commonPickerfiletype) {
          this.$refs.commonPickerfiletype.resetFile();
        }
      });
    },
    getFileKind() {
      API.getFileKind({}).then((res) => {
        // console.log("----附件类型:", res);
        if (res.ret == 0) {
          let temarr = [];
          this.newQuarterList = [];
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].code !== "common") {
                let obj = {
                  code: res.data[i].code,
                  text: res.data[i].desc,
                  desc: res.data[i].desc,
                };
                temarr.push(obj);
              }
            }
            this.newQuarterList.push(temarr);
          }
        }
      });
    },
    async getFieldsType(values) {
      console.log("-----新增了新的文件:", values);
      let isbool = await this.addNewField(values);
      console.log("----查看返回isbool:", isbool);
      if (isbool) {
        if (values && values.length > 0) {
          // for (let i = 0; i < values.length; i++) {
          // this.caseList.push(values[i]);
          // }
          this.initDetailFiles();
          document.getElementById("materialid").scrollIntoView(false);
        }
      }
    },
    choiceFielType() {
      if (this.caseList && this.caseList.length > 10) {
        this.$toast("最多可上传10个附件文件");
        return false;
      }
      this.cusmarker = true;
      this.isNeedemit = true;
      this.$refs.commonPickerfiletype.showPicker();
    },
    uploadBtn() {
      // this.cusmarker = true; // 只要进来了，没有点击上报则在离开页面时需要弹出提示框
      if (this.caseList && this.caseList.length <= 0) {
        this.$toast("请上传至少一个附件");
        return false;
      }
      if (this.caseList && this.caseList.length > 10) {
        this.$toast("最多可上传10个附件文件");
        return false;
      }
      if (this.caseList) {
        this.isShow = true;
        this.titleContent =
          "你已添加" + this.caseList.length + "项附件，是否确定上报";
      }
    },
    addNewField(newlist) {
      // 编辑时  一个一个新增文件接口
      return new Promise((resolve, reject) => {
        API.uploadFiel({
          fileResVOS: newlist,
          monitorType: this.monitorType,
          quarter: this.quarter,
          year: this.year,
          id: this.id,
          fileKind:
            newlist && newlist.length > 0 ? newlist[0].fileKind : "common",
        }).then((res) => {
          if (res.ret == 0) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    async getFields(value) {
      //直接调原生附件的
      let isbool = await this.addNewField(value);
      if (isbool) {
        if (value && value.length > 0) {
          for (let i = 0; i < value.length; i++) {
            this.caseList.push(value[i]);
          }
          document.getElementById("materialid").scrollIntoView(false);
        }
      }
    },
    cancelClick() {
      this.isShow = false;
      this.outisShow = false;
      // this.markermodal = 1;
    },

    async onOk() {
      const res2 = await API.submitFiel({
        area: this.area || "530100",
        monitorType: this.monitorType,
        msgId: "8a88899f736a03f901736a31f701003f",
        quarter: `${this.quarter}`,
        year: `${this.year}`,
        typeCode: "1",
        userId: JSON.parse(localStorage.getItem("appraiseNewLocalauthority"))
          .userId,
        // userId: ''
      });
      if (res2.ret === 0) {
        this.$toast("上报成功");
        const params = commonAPI.getJsonLocal("a1a2a3");
        if (params) {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.bottom-btn {
  position: fixed;
  bottom: 0;
  height: 60px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
}
.btn2 {
  // margin-left: 15px;
  width: 100%;
}
.divclass1 {
  margin-right: 15px;
  width: 100%;
}
.material {
  // padding: 16px 12px;
  margin-bottom: 120px;
}
</style>
